import React from 'react';
import styles from './index.module.css';

import logo from '@/assets/images/globis_logo.svg';

export const ErrorPageHeader = () => {
  return (
    <header className={styles.header}>
      <h1 className={styles.logo}>
        <a href="/">
          <img src={logo} alt="GLOBIS" />
        </a>
      </h1>
    </header>
  );
};
